import { configFetch as fetch } from '@meiqia/utils';
import { ENV_CONFIG } from '@meiqia/constants';

const notificationBaseUrl = ENV_CONFIG.NOTIFICATION_BASE_URL;

export const getNewNotificationNum = () =>
  fetch({
    baseURL: notificationBaseUrl,
    url: '/notify/unread_num',
    method: 'post',
    deleteEntid: true,
    data: {}
  });

export const getCommentHint = () =>
  fetch({
    baseURL: ENV_CONFIG.JAVA_API_URL,
    url: '/omni/comment/agent_read_comment_point/has_unread',
    method: 'post'
  }).then(res => res.data.data);
export const clearCommentHint = point =>
  fetch({
    baseURL: ENV_CONFIG.JAVA_API_URL,
    url: '/omni/comment/agent_read_comment_point/read',
    method: 'post',
    data: { point }
  });
